module.exports = __webpack_public_path__ + "img/dp-jy-sy17.acd29791.png";